import { render, staticRenderFns } from "./GameOverScene.vue?vue&type=template&id=111927ca&scoped=true&"
import script from "./GameOverScene.vue?vue&type=script&lang=js&"
export * from "./GameOverScene.vue?vue&type=script&lang=js&"
import style0 from "./GameOverScene.vue?vue&type=style&index=0&id=111927ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111927ca",
  null
  
)

export default component.exports